import React, { Component } from "react";
import { apiEndpoint } from "helpers/url_helper";

import { Map, HeatMap, GoogleApiWrapper } from "google-maps-react";
import isEmpty from 'lodash.isempty';
const mapStyles = {
  width: '100%',
  height: '95%',
};
const gradient = [
  "rgba(0, 255, 255, 0)",
  "rgba(0, 255, 255, 1)",
  "rgba(0, 191, 255, 1)",
  "rgba(0, 127, 255, 1)",
  "rgba(0, 63, 255, 1)",
  "rgba(0, 0, 255, 1)",
  "rgba(0, 0, 223, 1)",
  "rgba(0, 0, 191, 1)",
  "rgba(0, 0, 159, 1)",
  "rgba(0, 0, 127, 1)",
  "rgba(63, 0, 91, 1)",
  "rgba(127, 0, 63, 1)",
  "rgba(191, 0, 31, 1)",
  "rgba(255, 0, 0, 1)"
];
const google = window.google = window.google ? window.google : {}
const data = [

  { lat: 37.78763, lng: -122.394025 ,weight:0},
  { lat: 37.787767, lng: -122.39398699999998 ,weight:2},
  { lat: 37.787486, lng: -122.394452,weight:2 },

];
var collection=[];

class MapContainer extends React.Component {
  
  constructor() {
    super()
    this.state = {
      collection: [],     
    }  
  }
async UNSAFE_componentWillReceiveProps(nextProps) {
  // You don't have to do this check first, but it can help prevent an unneeded render
  if (nextProps.CampusID !== this.props.CampusID) {

    if(google.maps.visualization !=undefined){
      // UserValidated
      const url = apiEndpoint+'/GetLocationListLatLng';
    try {
    const response = await fetch(url, { 
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "intCampusID": nextProps.CampusID,
        "strToken": sessionStorage.getItem("Clear_AuthUser")
      })

    
    });
     if(response.body!=null){
    const data = await response.json();
  
        //console.log(JSON.parse(data.Locations) )
       
    this.setState({ collection: JSON.parse(data.Locations)  })
    const result=JSON.parse(data.Locations);
    if(data.Locations!=null){
    this.setState({ centre:{lat:result[0].lat,lng:result[0].lng}  })
    }
     }

} catch (error) {
    console.log(error);
}
  
    return true;
  }}
  
}

async  componentDidMount() {
  //console.log(google.maps.visualization);

if(this.props.CampusID!=undefined){
 
  if(google.maps.visualization !=undefined){
    // UserValidated
  const url = apiEndpoint+'/GetLocationListLatLng';
  try {
  const response = await fetch(url, { 
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      "intCampusID": this.props.CampusID,
      "strToken": sessionStorage.getItem("Clear_AuthUser")
    })
  
  });
   if(response.body!=null){
  const data = await response.json();

      //console.log(JSON.parse(data.Locations) )
     
  this.setState({ collection: JSON.parse(data.Locations)  })
  const result=JSON.parse(data.Locations);
  if(data.Locations!=null){
  this.setState({ centre:{lat:result[0].lat,lng:result[0].lng}  })
  }
   }

} catch (error) {
  console.log(error);
}
}}
}
  render() {
    //console.log(this.state.collection)

    //console.log(this.state.centre)
    return (
      
      <div className="map-container">
       
        {!isEmpty(this.state.collection) && (
         
        <Map 
          google={this.props.google}
          className={"map"}
          zoom={8}
          center={this.state.centre}
          onReady={this.handleMapReady}
          key={this.state.collection}
          style={mapStyles}
        >
          <HeatMap 
            gradient={gradient}
           positions={this.state.collection}
         //positions={data}
            opacity={1}
            radius={20}  
            style={{height:"100%"}} 
          />
        
        </Map>
        )}
      </div>
    );
  }
}
export default MapContainer;
